export function parseSelectedDate(isoDateStr) {
  if (!isoDateStr) {
    return {
      selectedDate: "",
      selectedDateDay: "",
      selectedDateMonth: "",
      selectedDateYear: "",
      selectedDateFullYear: "",
      selectedDateFull: "",
    };
  }

  const date = new Date(isoDateStr);

  if (isNaN(date.getTime())) {
    console.warn("Invalid date passed to parseSelectedDate:", isoDateStr);
    return {
      selectedDate: isoDateStr,
      selectedDateDay: "",
      selectedDateMonth: "",
      selectedDateYear: "",
      selectedDateFullYear: "",
      selectedDateFull: "",
    };
  }

  const day = String(date.getDate()).padStart(2, "0");

  const month = date.toLocaleString("en-US", {
    month: "long"
  });

  const year = String(date.getFullYear()).slice(-1); // last digit
  const fullYear = String(date.getFullYear());       // full 4-digit year

  // New variable for "May 10, 2025" format
  const selectedDateFull = date.toLocaleString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  return {
    selectedDate: isoDateStr,
    selectedDateDay: day,
    selectedDateMonth: month,
    selectedDateYear: year,
    selectedDateFullYear: fullYear,
    selectedDateFull,
  };
}
